import React, { useEffect, useState } from "react";
import TituloEscenario from "../titulo-escenario";
import TablaProyeccionesVI from "../tabla-proyecciones-vi";
import * as Funciones from "../../../../utils/funciones";
import * as Constantes from "../../../../utils/constantes";
import styles from "./escenarios.module.css"
import BotonExpandir from "../boton-expandir";

const Escenarios = ({ escenarios, moneda }) => {
    const initialState = {
        cantidadAnios: '',
        escenario: {
            ...escenarios.filter(escenario => escenario.nombre.indexOf('Esperado') !== -1)[0],
            id: 'Esperado'
        },
        proyecciones: [],
        expandido: false
    }

    const [ state, setState ] = useState(initialState);

    const onChangeInput = (valor, tipo) => {
        let cantidadAnios = Funciones.obtenerValor(valor, tipo)
        let proyecciones = []
        if(cantidadAnios === '') {
            proyecciones = state.escenario.proyecciones
        } else {
            proyecciones = state.escenario.proyecciones.filter(proyeccion => proyeccion.anio <= cantidadAnios)
        }
        if(!state.expandido) {
            proyecciones = proyecciones.filter(proyeccion => proyeccion.anio === 1 || proyeccion.anio % 5 === 0)
        }

        setState({
            ...state,
            cantidadAnios: cantidadAnios,
            proyecciones: proyecciones
        })
    }

    const onChangeEscenario = (idEscenario) => {
        let escenario = escenarios.filter(escenario => escenario.nombre.indexOf(idEscenario) !== -1)[0]
        setState({
            ...state,
            escenario:{
                ...escenario,
                id: idEscenario
            },
            proyecciones: escenario !== undefined && escenario.proyecciones.length > 0
                ? escenario.proyecciones.slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES) : [],
            expandido: false
        })
    }

    const expandirTabla = () => {
        let proyecciones = []
        if(state.cantidadAnios === '') {
            proyecciones = state.escenario.proyecciones
        } else {
            proyecciones = state.escenario.proyecciones.filter(proyeccion => proyeccion.anio <= state.cantidadAnios)
        }
        setState({
            ...state,
            proyecciones: !state.expandido
                ? proyecciones
                : (proyecciones !== undefined
                    ? proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                        .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES)
                    : []
                ),
            expandido: !state.expandido
        })
    }

    useEffect(() => {
        if(state.escenario.proyecciones !== undefined && state.escenario.proyecciones.length > 0) {
            setState({
                ...state,
                proyecciones: state.escenario.proyecciones.filter(proyeccion => (proyeccion.anio === 1 || proyeccion.anio % 5 === 0))
                    .slice(0, Constantes.CANTIDAD_REGISTROS_PROYECCIONES),
                expandido: false
            })
        }
    }, [ state.escenario ])

    return (
        <React.Fragment>
            <div className={styles.contenedor}>
                <input
                    className={styles.cantidad_anios}
                    placeholder='Elegir cantidad de años'
                    maxLength='2'
                    value={state.cantidadAnios}
                    onChange={(e) => onChangeInput(e.target.value, Constantes.TIPO_DATO_NUMERICO)}
                />

                {/* ESCENARIO ESPERADO */}
                <div
                    className={`${styles.escenario_opcion} ${state.escenario.id === 'Esperado' ? styles.escenario_opcion_select : null}`}
                    onClick={() => onChangeEscenario('Esperado')}>
                    <div className={`${styles.escenario_opcion_radio} ${state.escenario.id === 'Esperado' ? styles.escenario_opcion_radio_select : null}`}>
                        <div className={`${styles.hidden} ${state.escenario.id === 'Esperado' ? styles.escenario_opcion_point : null}`} />
                    </div>
                    <span className={styles.escenario_opcion_radio_label}>
                        Escenario Esperado
                    </span>
                </div>

                {/* ESCENARIO PESIMISTA */}
                <div
                    className={`${styles.escenario_opcion} ${state.escenario.id === 'Pesimista' ? styles.escenario_opcion_select : null}`}
                    onClick={() => onChangeEscenario('Pesimista')}>
                    <div className={`${styles.escenario_opcion_radio} ${state.escenario.id === 'Pesimista' ? styles.escenario_opcion_radio_select : null}`}>
                        <div className={`${styles.hidden} ${state.escenario.id === 'Pesimista' ? styles.escenario_opcion_point : null}`} />
                    </div>
                    <span className={styles.escenario_opcion_radio_label}>
                        Escenario Pesimista
                    </span>
                </div>

                {/* ESCENARIO OPTIMISTA */}
                <div
                    className={`${styles.escenario_opcion} ${state.escenario.id === 'Optimista' ? styles.escenario_opcion_select : null}`}
                    onClick={() => onChangeEscenario('Optimista')}>
                    <div className={`${styles.escenario_opcion_radio} ${state.escenario.id === 'Optimista' ? styles.escenario_opcion_radio_select : null}`}>
                        <div className={`${styles.hidden} ${state.escenario.id === 'Optimista' ? styles.escenario_opcion_point : null}`} />
                    </div>
                    <span className={styles.escenario_opcion_radio_label}>
                        Escenario Optimista
                    </span>
                </div>
            </div>

            <div className={styles.body}>
                <TituloEscenario
                    titulo={state.escenario.nombre}
                    subTitulo={state.escenario.descripcion}
                    sup='(1)'
                />
                <TablaProyeccionesVI
                    proyecciones={state.proyecciones}
                    moneda={moneda}
                />
                <BotonExpandir
                    proyecciones={state.proyecciones}
                    expandido={state.expandido}
                    expandirTabla={expandirTabla}
                    mostrarPoliticaInversion={true}
                />
            </div>
        </React.Fragment>
    )
}

export default Escenarios;